import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, lastValueFrom, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import type { OfficeLoginResponse } from '../models/office-login.model';

@Injectable({
  providedIn: 'root',
})
export class OfficeAuthService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.outlookApiBaseUrl;

  /**
   * Exchanges an Office SSO JWT for a Holli API bearer token (Passport).
   */
  async loginWithOfficeToken(officeToken: string): Promise<OfficeLoginResponse> {
    const url = `${this.baseUrl}/auth/office-login`;
    return lastValueFrom(
      this.http.post<OfficeLoginResponse>(url, { office_token: officeToken }).pipe(
        catchError((error: unknown) => {
          console.error('[OfficeAuthService]', error);
          return throwError(() => new Error(this.messageFromHttp(error)));
        }),
      ),
    );
  }

  private messageFromHttp(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        return 'Geen verbinding met de API (CORS of server bereikbaar?). Controleer outlookApiBaseUrl in environment.';
      }
      const body = error.error as { message?: string } | null;
      if (body != null && typeof body.message === 'string' && body.message.trim() !== '') {
        return body.message;
      }
      if (error.status === 409) {
        return 'Dit e-mailadres hoort bij een andere Holli-klant.';
      }
      if (error.status === 403) {
        return 'Geen Holli-klant gekoppeld aan deze Microsoft-tenant.';
      }
      if (error.status === 422) {
        return 'Ongeldige of onvolledige Office-token.';
      }
      if (error.status >= 500) {
        return 'De API is tijdelijk niet beschikbaar.';
      }
      return `API-login mislukt (HTTP ${error.status}).`;
    }
    return 'API-login mislukt.';
  }
}
